<template>
  <BittsEmptyState
    class="bg-white border-none"
    :font-awesome-icon-style="{ height: '52px', width: '52px' }"
    font-awesome-icon-class="copilot__empty-state-icon"
    :font-awesome-icon
    :title
    :description
    :link
  />
</template>

<script setup lang="ts">
import BittsEmptyState from '../BittsEmptyState/BittsEmptyState.vue';
import { BittsLinkProps } from '../BittsLink/BittsLink.vue';
import { BittsIcon } from '../types';

defineProps<{
  fontAwesomeIcon: BittsIcon;
  title: string;
  description: string;
  link?: BittsLinkProps;
}>();
</script>

<style lang="pcss">
@reference "../../../../apps/crossbeam-app/src/css/theme.css";
.copilot__empty-state-icon {
  @apply text-neutral-accent p-20 rounded-[360px];
  background: radial-gradient(
      136.96% 69.92% at 50.09% -12.42%,
      theme(colors.neutral.accent / 0.2) 0%,
      theme(colors.neutral.accent / 0) 100%
    ),
    linear-gradient(0deg, theme(colors.white), theme(colors.white));
}
</style>
